import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BiUpArrowAlt, BiDownArrowAlt } from "react-icons/bi";
import { BotaoComecar, Flash, ContagemRegressiva, MostradorFotos, Quadro, SecaoFotos, Texto, CameraFotos, SecaoFotosSemBorda, Alinhar, MensagemFinal } from "./FotosStyled";
import { atualizaEtapa, getTicket } from "../../servicos/ticketsServices";
import { salvarFoto } from "../../servicos/fotosServices";
import { usuarioAtual } from "../../servicos/usuariosServices";
import Titulo1 from "../../componentes/Titulo1";
import ModalAviso from "../../componentes/ModalAviso";
import ErroSpan from "../../componentes/ErroSpan";

export default function Fotos() {
	const [ticketLido, setTicketLido] = useState({});
	const [etapa, setEtapa] = useState(1);
	const [foto, setFoto] = useState([]);
	const [selecionado, setSelecionado] = useState(0);
	const [piscar, setPiscar] = useState("0");
	const [regressiva, setRegressiva] = useState({
		mostrar: false,
		contagem: 5
	});
	const [regressiva2, setRegressiva2] = useState(null);
	const [aviso, setAviso] = useState({
		mostrar: false,
		texto: ""
	});
	const [carregando, setCarregando] = useState(false);
	const videoRef = useRef();
	const canvasRef = useRef();
	const timeout = 60;		// Tempo em segundos para sair da tela se nenhuma ação for tomada
	const [dimensoesJanela, setDimensoesJanela] = useState({
		largura: window.innerWidth,
		altura: window.innerHeight
	});
	const navigate = useNavigate();
	const avisoMostrarRef = useRef(aviso.mostrar);
	const inputRef = useRef(null);
	const [buffer, setBuffer] = useState("");

	async function startCamera() {
		try {
			const stream = await navigator.mediaDevices.getUserMedia({ facingMode: 'user', video: { width: 1920, height: 1080 }, audio: false });
			videoRef.current.srcObject = stream;
		} catch (error) {
			console.error('Erro ao acessar webcam:', error);
		}
	};
	async function stopCamera() {
		try {
			const video = videoRef.current;
			video.srcObject.getTracks().forEach((track) => {
				track.stop();
			});
		} catch (e) {
			console.log(e.message);
		}
	}
	function tirarFoto() {
		setPiscar("1");
		const video = videoRef.current;
		const canvas = canvasRef.current;

		const context = canvas.getContext('2d');
		canvas.width = 1920;
		canvas.height = 1080;
		canvas.aspectRatio = 1920 / 1080;
		context.drawImage(video, 0, 0, canvas.width, canvas.height);

		// Convert the captured frame to a data URL
		const dataUri = canvas.toDataURL('image/jpeg', 0.85);

		return dataUri;
	}
	function selecionouFoto(numero) {
		setSelecionado(numero);
		salvarFoto(foto[numero], ticketLido.numero, ticketLido.visitante);
		setEtapa(5);
		setRegressiva({
			mostrar: false,
			contagem: 5,
			inicio: Math.floor(Date.now() / 1000) + 5
		});
		setRegressiva2(null);
		atualizaEtapa(ticketLido.numero, 0);
		inputRef.current?.focus();
	}
	useEffect(() => {
		avisoMostrarRef.current = aviso.mostrar;
	}, [aviso.mostrar]);
	useEffect(() => {
		if (etapa === 3) {
			const interval = setInterval(() => {
				setPiscar("0");
				if (foto.length === 0) setRegressiva({
					...regressiva,
					contagem: regressiva.inicio - Math.floor(Date.now() / 1000) + 10
				}); else setRegressiva({
					...regressiva,
					contagem: regressiva.inicio - Math.floor(Date.now() / 1000) + 3
				});
				if (regressiva.contagem <= 1) {
					setFoto([...foto, tirarFoto()]);
					if (foto.length === 2) {
						setRegressiva({
							mostrar: false,
							contagem: 5
						});
						atualizaEtapa(ticketLido.numero, 4);
						setEtapa(4);
						setRegressiva2(timeout);
					} else {
						setRegressiva({
							mostrar: true,
							contagem: 3,
							inicio: Math.floor(Date.now() / 1000)
						});
					}
				}
			}, 1000);
			return () => clearInterval(interval);
		} else if (etapa === 5) {
			const interval = setInterval(() => {
				setRegressiva({
					...regressiva,
					contagem: regressiva.inicio - Math.floor(Date.now() / 1000) + 1
				});
				if (regressiva.contagem <= 0) {
					setFoto([]);
					setEtapa(1);
				}
			}, 1000);
			return () => clearInterval(interval);
		}
	}, [regressiva, etapa, foto, ticketLido]);
	useEffect(() => {
		if (regressiva2) {
			const interval = setInterval(() => {
				setRegressiva2(regressiva2 - 1);
				if (regressiva2 <= 1) {
					if (aviso.mostrar) {
						setAviso({
							mostrar: false,
							texto: ""
						});
					} else {
						if (ticketLido?.numero) atualizaEtapa(ticketLido.numero, -1);
						setEtapa(1);
						setAviso({
							mostrar: true,
							texto: "Tempo esgotado."
						});
						setRegressiva2(10);
						setFoto([]);
					}
				}
			}, 1000);
			return () => clearInterval(interval);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [regressiva2])
	useEffect(() => {
		usuarioAtual().then(res => {
			if (!res || res.status !== 200) navigate("/login", { state: { redirecionar: window.location.pathname } });
		});
		const handleResize = () => {
			setDimensoesJanela({
				largura: window.innerWidth,
				altura: window.innerHeight,
			});
		};
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// useEffect para manter o foco da página no input 
	useEffect(() => {
		// foca ao montar
		const focaInput = () => {
			try {
				inputRef.current?.focus();
			} catch (e) {
				/* ignore */
			}
		};

		focaInput();

		// se a aba ganhar visibilidade, refoca
		const handleVisibility = () => {
			if (document.visibilityState === "visible") focaInput();
		};
		document.addEventListener("visibilitychange", handleVisibility);

		return () => {
			document.removeEventListener("visibilitychange", handleVisibility);
		};
	}, []);

	function verificaTicket(ticket) {
		setCarregando(true);
		setBuffer("");
		ticket = ticket.replace("NumLock", "");
		getTicket(ticket).then(res => {
			try {
				if (res.mensagem === "Token inválido!") {
					navigate("/login", { state: { redirecionar: window.location.pathname } });
				} else if (res.mensagem === "Ingresso inválido!") {
					console.log(res);
					setAviso({
						mostrar: true,
						texto: "Ingresso inválido!"
					});
					setRegressiva2(15);
				} else if (res.tickets.length === 0) {
					setAviso({
						mostrar: true,
						texto: "Ingresso não econtrado!"
					});
					setRegressiva2(15);
				} else {
					let ultimaAtt = new Date(res.tickets[0].atualizadoEm) // Data e horario da última atualização no ingresso

					// Verifica se a última atualização faz mais de 1 min e ficou preso na etapa 2
					if (res.tickets[0]?.etapaFoto === 2 && ultimaAtt.getTime() + 60*1000 < (new Date()).getTime()) res.tickets[0].etapaFoto = -1;

					if (res.tickets[0]?.etapaFoto >= 0) {
						setAviso({
							mostrar: true,
							texto: "Ingresso já utilizado!"
						});
						setRegressiva2(15);
					} else {
						atualizaEtapa(res.tickets[0].numero, 2);
						setTicketLido(res.tickets[0]);
						setEtapa(2);
						setRegressiva2(timeout);
					}
				}
			} catch (e) {
				console.log(e.message);
				setAviso({
					mostrar: true,
					texto: "Ingresso inválido"
				});
				setRegressiva2(15);
			}
			setCarregando(false);
		});
	}
	function mensagemFinal() {
		if (ticketLido?.visitante?.celular) {
			return (<>
				<Texto $bold="500" $tamanho="45px">Sua foto será adicionada</Texto>
				<Texto $bold="500" $tamanho="45px">ao mural de visitantes e</Texto>
				<Texto $bold="500" $tamanho="45px">enviada via WhatsApp!</Texto>
			</>);
		} else if (ticketLido?.visitante?.email) {
			return (<>
				<Texto $bold="500" $tamanho="45px">Sua foto será adicionada</Texto>
				<Texto $bold="500" $tamanho="45px">ao mural de visitantes e</Texto>
				<Texto $bold="500" $tamanho="45px">enviada via email!</Texto>
			</>);
		} else {
			return (<>
				<Texto $bold="500" $tamanho="45px">Sua foto será adicionada</Texto>
				<Texto $bold="500" $tamanho="45px">ao mural de visitantes!</Texto>
			</>);
		}
	}

	// Trata entrada de dados no input do ingresso (feita pelo leitor QR Code)
	const handleKeyDown = (e) => {
		// Se for tecla de controle, ignorar
		if (
			e.key === "Shift" ||
			e.key === "Control" ||
			e.key === "Alt" ||
			e.key === "CapsLock" ||
			e.key === "NumLock" ||
			e.key === "Meta" ||
			e.key === "Tab" ||
			e.key === "Escape" ||
			e.key.startsWith("F") // F1, F2, ... F12
		) {
			return;
		}
		// Se for enviado um "ENTER" / Quando o leitor finalizar
		if (e.key === "Enter") {
			if (etapa === 1 && buffer.trim() !== "" && !aviso.mostrar) {
				// Limpa algum aviso que estiver ativo
				setAviso({
					mostrar: false,
					texto: ""
				});
				// Busca o ingresso
				verificaTicket(buffer);
			}

			setBuffer("");        // Limpa o buffer
			e.target.value = "";  // Limpa o input
		} else if (etapa === 1) {
			// Vai acumulando os caracteres até o Enter
			setBuffer((prev) => prev + e.key);
		}
	};

	// handler de blur: refoca depois do loop de eventos para não atrapalhar clicks
	const handleBlur = () => {
		// pequeno delay para permitir que o click/handler do botão execute antes do foco voltar
		setTimeout(() => {
			if (inputRef.current && document.activeElement !== inputRef.current) {
				inputRef.current.focus();
			}
		}, 0);
	};

	function etapas() {
		if (etapa === 1) {
			return (<>
				<Texto $pad={`${15 * dimensoesJanela.altura / 768}px`} $fundo="var(--corNugaliEscura)" $bold="300" $largura="600px" $cor="#F3DEC4" $tamanho="32px" $margem={`${10 * dimensoesJanela.altura / 768}px auto 0 auto`}>Olá! Vamos fazer uma foto da sua visita?</Texto>
				<Texto $tamanho={`${32 * dimensoesJanela.altura / 768}px`} $margem={`${20 * dimensoesJanela.altura / 768}px 0 0 0`}>Posicione o QR Code de seu ingresso</Texto>
				<Texto $tamanho={`${32 * dimensoesJanela.altura / 768}px`} $margem={`0 0 ${30 * dimensoesJanela.altura / 768}px 0`}>em frente ao leitor abaixo!</Texto>
				<BiDownArrowAlt className="Icone" style={{ width: "120px", height: "120px", position: "absolute", bottom: "30px", margin: "auto", left: "50%", transform: "translateX(-50%)" }} />
			</>);
		} else if (etapa === 2) {
			return (<>
				<Titulo1
					$tamanho="42px"
					$alinhamento="center"
					$margem={`${20 * dimensoesJanela.altura / 768}px 0 0 0`}
					$pad="0"
					$cor="var(--corNugaliEscura)"
					$corFundo="transparent">Vamos tirar três fotos e você</Titulo1>
				<Titulo1
					$tamanho="42px"
					$alinhamento="center"
					$margem={`0 0 0 0`}
					$pad="0"
					$cor="var(--corNugaliEscura)"
					$corFundo="transparent">escolhe a que mais gostou</Titulo1>
				<Texto
					$tamanho="42px"
					$bold="300"
					$margem={`${40 * dimensoesJanela.altura / 768}px 0 ${80 * dimensoesJanela.altura / 768}px 0`}><BiUpArrowAlt className="Icone" /> Não esqueça de olhar para a câmera <BiUpArrowAlt className="Icone" /></Texto>
				<BotaoComecar $margem="auto" onClick={() => {
					atualizaEtapa(ticketLido.numero, 3);
					setEtapa(3);
					startCamera();
					setRegressiva({
						mostrar: true,
						contagem: 10,
						inicio: Math.floor(Date.now() / 1000)
					});
					setRegressiva2(null);
				}}>COMEÇAR</BotaoComecar>
			</>);
		} else if (etapa === 3) {
			return (<>
				<ContagemRegressiva $mostrar={regressiva.mostrar}>{regressiva.contagem}</ContagemRegressiva>
				<CameraFotos constraints={{ aspectRatio: "1.7777" }} ref={videoRef} autoPlay={true} />
				<canvas ref={canvasRef} style={{ display: 'none' }} />
			</>);
		} else if (etapa === 4) {
			if (piscar === "1") {
				setPiscar("0");
				stopCamera();
			}
			return (<>
				<Texto $tamanho="2.5em" $margem={`${50 * dimensoesJanela.altura / 768}px 0 ${150 * dimensoesJanela.altura / 768}px 0`} $cor="var(--corNugaliEscura)" $corFundo="transparent">Toque na foto que mais gostou!</Texto>
				<MostradorFotos>
					<Quadro onClick={() => selecionouFoto(0)} src={foto[0]} alt="Foto1" />
					<Quadro onClick={() => selecionouFoto(1)} src={foto[1]} alt="Foto2" />
					<Quadro onClick={() => selecionouFoto(2)} src={foto[2]} alt="Foto3" />
				</MostradorFotos>
			</>)
		} else if (etapa === 5) {
			return (<>
				<Alinhar>
					<MensagemFinal>
						<Texto $tamanho="45px" $margem={`0 50px 30px 0`} $cor="var(--corNugaliEscura)" $corFundo="transparent">Obrigado!</Texto>
						{mensagemFinal()}
					</MensagemFinal>
					<Quadro src={foto[selecionado]} alt="Foto Escolhida" $largura="700px" $margem={`${20 * dimensoesJanela.altura / 768}px ${20 * dimensoesJanela.altura / 768}px ${10 * dimensoesJanela.altura / 768}px ${40 * dimensoesJanela.altura / 768}px`} $roda="rotate(8deg)" $pad={`${15 * dimensoesJanela.altura / 768}px ${15 * dimensoesJanela.altura / 768}px ${40 * dimensoesJanela.altura / 768}px ${15 * dimensoesJanela.altura / 768}px`} />
				</Alinhar>
			</>)
		}
	}

	const fecharAviso = () => {
		setAviso({
			mostrar: false,
			texto: ""
		});
		setRegressiva2(0);
	}

	return (<>
		{carregando && <ErroSpan>Carregando...</ErroSpan>}
		{/* Input invisível SEMPRE presente no DOM */}
		<input
			ref={inputRef}
			type="text"
			onKeyDown={handleKeyDown}
			onBlur={handleBlur}
			autoComplete="off"
			inputMode="text"
			// mantém o input fora do fluxo visual, mas ainda focusable programaticamente
			style={{
				position: "absolute",
				left: "-9999px",
				top: "auto",
				width: "1px",
				height: "1px",
				opacity: 0,
				border: "none",
				padding: 0,
				margin: 0,
			}}
		/>

		{/* Render condicional das etapas */}
		{etapa === 3 ? (
			<SecaoFotosSemBorda>
				{ModalAviso(aviso.texto, aviso.mostrar, fecharAviso, "80px")}
				{piscar === "1" && <Flash />}
				{etapas()}
			</SecaoFotosSemBorda>
		) : (
			<SecaoFotos>
				{ModalAviso(aviso.texto, aviso.mostrar, fecharAviso, "auto")}
				{piscar === "1" && <Flash />}
				{etapas()}
			</SecaoFotos>
		)}
	</>);
}